import { gql, useQuery } from '@apollo/client';

export const GET_PROCESS_TASK_TEMPLATE = gql`
  query getProcessTaskTemplate($taskTemplateId: ObjectId!) {
    getProcessTaskTemplate(taskTemplateId: $taskTemplateId) {
      _id
      name
      createdBy
      platformCompanyId
      emailTemplateId
      templateTasksIds
      templateTasks {
        _id
        title
        createdBy
        jobId
        assignTo
        details
        companyId
        responsiblePersonsIds
        departmentId
        deadlineInDays
        checklist {
          title
          completed
        }
      }
    }
  }
`;

export const useGetProcessTaskTemplate = (taskTemplateId?: string) => {
  const { data, loading } = useQuery(GET_PROCESS_TASK_TEMPLATE, {
    variables: { taskTemplateId },
    skip: !taskTemplateId,
    fetchPolicy: 'network-only',
  });

  const processTaskTemplate = data?.getProcessTaskTemplate || {};

  return { loading, processTaskTemplate };
};
